import axios from 'axios';
import { Toast } from 'vant';
import getUrlKey from '../utils/getParams'
import isiOS from "@/utils/iosAn";

// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL


// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        config.headers['sessionId'] = getUrlKey('sessionId');
        // config.headers['sessionId'] = 123456;
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 0 || response.data.code === 20000) {
            return Promise.resolve(response);
        } else {
            if (response.data.code) {
                switch (response.data.code) {
                    // -10000: sessionId已经过期               
                    case -10000:
                        // Toast({
                        //     message: 'sessionId已经过期',
                        //     duration: 1000,
                        //     forbidClick: true
                        // });
                        setTimeout(() => {
                            if (isiOS) {
                                window.webkit.messageHandlers.JSCallNative.postMessage({type:"-10000"});
                            } else {
                                window.android.JSCallNative(JSON.stringify({type:"-10000"}));
                            }
                        }, 1000);
                        break;
                    case -1:
                        Toast(response.data.message);
                        break;
                    case 404:
                        Toast({
                            message: '网络请求不存在',
                            duration: 1500,
                            forbidClick: true
                        });
                        break;
                    // 其他错误，直接抛出错误提示                
                    default:
                        Toast({
                            message: response.data.message,
                            duration: 1500,
                            forbidClick: true
                        });
                }
                return Promise.reject(response);
            }
        }
    },
    // 服务器状态码不是0的情况    
    error => {
        Toast("Server error")
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}